/* eslint-disable no-confusing-arrow */
import React from "react"
import { Alert, Button } from "reactstrap"
// import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer"
import { PDFViewer } from "@react-pdf/renderer"
import { PrintOrderPDF } from "components/utility"
import { useQueryData } from "utils"
import { Spinner } from "components/spinner"
import { withBasicNotify } from "components/notification"
import { GET_ORDER } from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const PdfContainer = (props) => {
  const orderId = props.match.params.id
  const { data, loading, error } = useQueryData(GET_ORDER, {
    skip: !orderId,
    variables: { id: orderId },
    fetchPolicy: "cache-and-network"
  })

  if (loading) {
    return <Spinner />
  }

  if (error) {
    return <Alert color="danger">錯誤訊息：{`${error}`}</Alert>
  }

  return (
    <div>
      <Button
        color="success"
        className="m-3"
        onClick={() => {
          props.history.goBack()
        }}
      >
        回到上一頁
      </Button>
      <PDFViewer style={{ width: "100%", height: "600px" }}>
        <PrintOrderPDF order={data?.order} />
      </PDFViewer>
    </div>
  )
}

export default withBasicNotify(PdfContainer)
